// Generic email rule used by Add/Edit forms and the real-time input validator.
// The rule is selected through the DB validation type `email`; it contains no
// module or field-name assumptions.
export function isValidConfiguredEmail(value) {
  const email = String(value ?? '').trim();
  const match = /^([^\s@]+)@([^\s@]+)\.([A-Za-z]{2,})$/.exec(email);
  if (!match) return false;

  const [, localPart, domainHost] = match;
  return /[A-Za-z]/.test(localPart) && /[A-Za-z]/.test(domainHost);
}

export function configuredEmailRule(label = 'Email', message) {
  return {
    validator: (_, value) => {
      if (value === undefined || value === null || value === '') return Promise.resolve();
      return isValidConfiguredEmail(value)
        ? Promise.resolve()
        : Promise.reject(new Error(message ?? `Enter a valid ${label}; numeric-only email addresses are not allowed`));
    },
  };
}
